<div class="backdrop"
     ></div>
<div class="modal"
     tabindex="-1"
     role="dialog"
     >
  <div class="modal-dialog"
       role="document"
       >
    <div class="modal-content">
      <div class="modal-header">
        <button type="button"
                class="close"
                (click)="popupCancel()"
                aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
        <h4 class="modal-title">Running</h4>
      </div>
      <div class="modal-body">
        Sensitivity analysis is now running. Check the 'define' tab to check the progress of the simulation.
        <button class="mat-raised-button btn-green"
                mat-raised-button
                (click)="popupCancel()">
          close
        </button>
      </div>
    </div>
  </div>
</div>
